// Single inference - GET /v1/inference/<uid>
const action = "INFERENCE_DETAIL";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

export const fetchRequest = (uid) => ({ type: REQUEST, payload: { uid } });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = () => ({ type: CLEAR });
